/**
 * @generated SignedSource<<b2335196e7ec7a803624759c68802955>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StoryPointsGroupHeader$data = {
  readonly number: number | null | undefined;
  readonly " $fragmentType": "StoryPointsGroupHeader";
};
export type StoryPointsGroupHeader$key = {
  readonly " $data"?: StoryPointsGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoryPointsGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StoryPointsGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ],
  "type": "JiraJqlNumberFieldValue"
};

(node as any).hash = "2d04d7c6471553920e11294e9de46cab";

export default node;
